<template>
  <div class="banner">
    <Form :model="searchCondition" inline>
      <FormItem label="发布平台" :label-width="70">
        <Select v-model="searchCondition.client" style="width:200px;" clearable>
          <Option v-for="item in bannerPlatform" :value="item.key" :key="item.key">{{item.value}}</Option>
        </Select>
      </FormItem>
      <FormItem class="search-form-btns">
        <div class="btn-wrap form-item-search">
          <Button icon="ios-search" @click="onSearch">搜索</Button>
          <Button icon="md-undo" @click="onReset">重置</Button>
        </div>
      </FormItem>
    </Form>
    <div>
      <Button type="primary" @click="onAddBanner" class="btn-margin-right">新建banner</Button>
    </div>
    <div class="content">
      <Grid
        ref="grid"
        :columns="tableColumns"
        data-url="/api/banner"
        :search="searchCondition"
        :rowsFormatter="onrowsFormatter"
        selectType
        keyField="id"
        method="get"
      >
        <template slot-scope="{row}" slot="c1">
          <img class="table-avatar" :src="row.banner_img" style="max-width:200px;max-height:100px;" />
        </template>
        <template slot-scope="{row}" slot="action">
          <div>
            <Button type="text" size="small" @click="onDetail(row)">编辑</Button>
            <span>-</span>
            <Button type="text" size="small" @click="onDelete(row)">删除</Button>
          </div>
        </template>
      </Grid>
    </div>
  </div>
</template>

<script>
import { BannerPlatform } from "@/utils/enums";

export default {
  data() {
    return {
      searchCondition: {
        client: "",
        init() {
          this.client = "";
        }
      },
      bannerPlatform: BannerPlatform.getOptions(),
      tableColumns: [
        { title: "banner图", slot: "c1", align: "center", minWidth: 200 },
        {
          title: "链接",
          key: "link_content_name",
          align: "center",
          minWidth: 120
        },
        {
          title: "发布平台",
          key: "client_type",
          align: "center",
          minWidth: 120
        },
        { title: "发布人", key: "create_user", align: "center", minWidth: 120 },
        {
          title: "创建时间",
          key: "created_at",
          align: "center",
          minWidth: 160
        },
        {
          title: "排序",
          key: "sort",
          align: "center",
          minWidth: 120
        },
        {
          title: "操作",
          slot: "action",
          align: "center",
          minWidth: 120,
          fixed: "right"
        }
      ]
    };
  },
  methods: {
    // on-event
    onSearch() {
      this.$refs.grid.searchRefresh();
    },
    onReset() {
      this.searchCondition.init();
      this.$refs.grid.searchRefresh();
    },
    onAddBanner() {
      this.$router.push({
        name: "BannerEdit"
      });
    },
    onrowsFormatter(rows) {
      rows.forEach(i => {
        if (i.link_type != 1) {
          i.link_content = "无链接";
        }
        const tmpAry = i.client_type.split(",");
        const tmpAry1 = [];
        tmpAry.forEach(ci => {
          tmpAry1.push(BannerPlatform.getValue(ci));
        });
        i.client_type = tmpAry1.join();
        i.created_at = this.$pub.timestampToTime(i.created_at);
      });
    },
    onDetail(row) {
      this.$router.push({
        name: "BannerEdit",
        query: {
          id: row.id //row前面不用加前缀
        }
      });
    },
    onDelete(row) {
      this.$Modal.confirm({
        //modal对话框实例化方法
        title: "提示",
        content: "<p>确定删除该banner么</p>",
        onOk: async () => {
          await this.$http.delete("/api/banner/" + row.id);
          this.$Message.deleteSuccess();
          this.$refs.grid.refresh();
        }
      });
    }
    // other
    // request
  }
};
</script>

<style lang="scss" scoped>
.bannner {
  .btn-group {
    float: left;
  }
  .page {
    float: right;
  }
}
</style>
